module.exports = __webpack_public_path__ + "img/image135.92a54bb7.png";